<template>
  <div class="main-section-container">
    <div class="home">
      <RetailerNavBar
        :contact="this.contact"
        v-on:submenu-selected="subMenuSelected"
      />
      <div class="columns main-body">
        <div class="column is-2 left-column">
          <RetailerLeftNav
            :collections="this.collections"
            :firstCollection="this.selectedCollection[0]"
            :selectedSubmenu="this.selectedSubmenu"
            :styleNumber="this.styleNumber"
            v-on:load-initial="this.loadInitialProducts"
            v-on:collection-selected="collectionSelected"
            v-on:product-type-selected="productTypeSelected"
            v-on:shape-selected="shapeSelected"
          />
        </div>
        <div class="column">
          <ProductGrid
            :products="this.products"
            :selectedSubmenu="this.selectedSubmenu"
            :selectedCollection="this.selectedCollection"
            :styleNumber="this.styleNumber"
            :selectedProductType="this.selectedProductType"
            :isLoading="this.isLoading"
            :addCollection="this.addCollection"
            :dialogActive="this.dialogActive"
            v-on:shape-cleared="shapeCleared"
            v-on:add-collection="$router.push('upload')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Dialog } from "buefy/dist/components/dialog";
import RetailerNavBar from "@/components/RetailerNavBar";
import RetailerLeftNav from "@/components/RetailerLeftNav";
import ProductGrid from "@/components/ProductGrid";
import Catalog from "@/services/catalog";
import _ from "lodash";

export default {
  name: "RetailerHome",
  components: {
    RetailerNavBar,
    RetailerLeftNav,
    ProductGrid,
  },
  data: function () {
    return {
      collections: [],
      selectedCollection: [
        {
          product_type: "",
        },
      ],
      selectedSubmenu: "Dresses",
      products: [],
      shapeSelect: false,
      styleNumber: null,
      contact: null,
      addCollection: false,
      collectionAdded: false,
      dialogActive: false,
      selectedProductType: "Dresses",
      isLoading: false,
      loadingImage: require("@/assets/images/Spinner.gif"),
    };
  },
  created: function () {
    this.checkSavedShape();
    // var contactId;
    // if (this.$route.query.contact) {
    //   contactId = this.$route.query.contact;
    // } else {
    //   contactId = localStorage.getItem("contactId");
    // }
    // if (contactId) {
    //   Catalog.identifyContact(contactId).then((contact) => {
    //     this.contact = contact;
    //     // Save this contact into local storage for later
    //     localStorage.setItem("contactId", this.contact.id);
    //   });
    // }
    this.isLoading = true;
    Catalog.loadCollections(this.selectedProductType).then((collections) => {
      this.isLoading = false;
      this.collections = collections;
      if (this.$route.params.collectionId) {
        this.collectionSelected([
          _.find(this.collections, { id: this.$route.params.collectionId }),
        ]);
      } else {
        this.loadInitialProducts();
        if (this.collections.length == 1) {
          this.collectionSelected(this.collections[0])
        }
      }
    });
    this.collectionAdded = localStorage.getItem("collection-added");
    if (this.collectionAdded) {
      this.addCollection = true;
    }
  },
  mounted: function () {
    this.$ga.page({
      page: "/",
      title: "Demo Home",
    });
  },
  methods: {
    loadInitialProducts: function () {
      this.isLoading = true;
      return Catalog.loadInitialProducts(
        this.selectedSubmenu,
        this.styleNumber
      ).then((products) => {
        this.isLoading = false;
        this.products = this.sortProducts(products);
      });
    },
    sortProducts: function (products) {
      if (localStorage.getItem("style-number")) {
        const recommendedProds = products.filter(
          (prod) => prod.product_recommendations.length > 0
        );
        return recommendedProds.sort(
          (a, b) =>
            b.product_recommendations[0].score -
            a.product_recommendations[0].score
        );
      } else {
        return products;
      }
    },
    subMenuSelected: function (submenu) {
      this.selectedSubmenu = submenu.split(" ").pop();
      this.selectedProductType = this.selectedSubmenu;
      // const isSelected =
      //   this.selectedCollection.some((i) => i["product_type"] != "") &&
      //   this.selectedCollection.some(
      //     (i) => i["product_type"] == this.selectedSubmenu
      //   );
      // isSelected ? this.loadCollection() : this.loadInitialProducts();
      this.isLoading = true;
      Catalog.loadCollections(this.selectedProductType).then((collections) => {
        this.isLoading = false;
        this.collections = collections;
        this.loadInitialProducts()
      });
    },
    collectionSelected: function (collection) {
      this.selectedCollection = collection;
      this.selectedProductType = null;
      const isSelected = this.selectedCollection.some(
        (i) => i["product_type"] != ""
      );
      const selectedCollectionNames = this.selectedCollection.map(
        (collection) => collection.name
      );
      this.$ga.event({
        eventCategory: "collection",
        eventAction: "select",
        eventLabel: "Select Collections " + selectedCollectionNames,
      });
      isSelected ? this.loadCollection() : this.loadInitialProducts();
    },
    shapeSelected(shapeToken) {
      this.styleNumber = shapeToken;
      this.$ga.event({
        eventCategory: "shape",
        eventAction: "select",
        eventLabel: "Select Shape " + this.styleNumber.token,
      });
      if (this.selectedCollection.some((i) => i["product_type"] != "")) {
        // We already have a selected Collection, just reload with styleNumber
        this.loadCollection();
      } else {
        this.products.forEach((product, index) => {
          this.isLoading = true;
          Catalog.loadProductRecommendations(product, shapeToken).then(
            (product) => {
              this.isLoading = false;
              Vue.set(this.products, index, product);
            }
          );
        });
      }
      // this.addCollection = true
    },
    checkSavedShape() {
      this.styleNumber = localStorage.getItem("style-number");
      if (this.styleNumber) {
        // We already have a saved style number in local storage
        this.shapeSelected(this.styleNumber);
      }
    },
    shapeCleared() {
      this.styleNumber = null;
    },
    loadCollection() {
      console.log("Loading Collection")
      this.products = [];
      this.isLoading = true;
      this.selectedCollection.forEach((collection) => {
        if (collection.id) {
          Catalog.loadCollectionProducts(collection, this.styleNumber).then(
            (products) => {
              this.isLoading = false;
              this.products.unshift(...products);
              this.products = this.sortProducts(this.products);
            }
          );
        }
      });
    },
    showAddCollectionDialog() {
      if (!this.collectionAdded && !this.addCollection) {
        // We would like to know that the user has added a collection at some point
        Dialog.confirm({
          title: "Add your own Collection?",
          message:
            "Would you like to try your products and run them through a lite version of Shape Intelligence?",
          confirmText: "Yes",
          cancelText: "Later",
          type: "is-success",
          hasIcon: true,
          onConfirm: () => {
            this.$router.push("upload");
          },
          onCancel: () => {
            this.addCollection = true;
          },
        });
      }
    },
    productTypeSelected(productType) {
      this.selectedCollection = [
        {
          product_type: "",
        },
      ];
      this.selectedProductType = productType;
      this.products = null;
      this.isLoading = true;
      Catalog.loadCollectionsByProductType(productType, this.styleNumber).then(
        (products) => {
          this.products = this.sortProducts(products);
          this.isLoading = false;
        }
      );
    },
  },
};
</script> 
